import { render, staticRenderFns } from "./skin-select.vue?vue&type=template&id=d2ecb3d0&"
import script from "./skin-select.vue?vue&type=script&lang=js&"
export * from "./skin-select.vue?vue&type=script&lang=js&"
import style0 from "./skin-select.vue?vue&type=style&index=0&id=d2ecb3d0&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports